export default function initMenu() {
    const body = document.body;
    const hamburger = document.querySelector('.hamburger');
    const sidebar = document.querySelector('.sidebar');
    const overlay = document.querySelector('.overlay');
    const items = sidebar.querySelectorAll('a');
    let active = false;

    hamburger.addEventListener("click", toggle);
    overlay.addEventListener("click", close);

    items.forEach(item => {
        item.addEventListener("click", close);
    })

    function toggle() {
        if(!active) {
            open();
        } else {
            close();
        }
    }

    function open() {
        body.classList.add("menu-open");
        sidebar.classList.add("active");
        overlay.classList.add("active");
        hamburger.classList.add("active");
        active = true;
    }

    function close() {
        body.classList.remove("menu-open");
        sidebar.classList.remove("active");
        overlay.classList.remove("active");
        hamburger.classList.remove("active");
        active = false;
    }
}